// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_g-0";
export var skeletonCard = "_g-1";